import { __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type any */
const Relative = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Position, Object.assign({ position: "relative", ref: ref }, props), children));
});
export default Relative;
